import React from 'react';
import { ContextMenu, Item, ContextMenuProvider, theme } from 'react-contexify';
import { 
  circleColor, 
  format, 
  inputFill, 
  fillUpside, 
  priceColor, 
  fillFiftyDayAvg,
  fillMLPrice, 
  earningDateColor, 
  fillMaxMin, 
  formatPercent, 
  fillStockWeight,
  stockReportLink
} from '../Helpers';

const TableRow = ({ 
  sector, 
  tickerInfo, 
  updateStockInput, 
  updateDbStockInput, 
  openModal, 
  activePortfolioId, 
  theme: currentTheme, 
  hide,
  toggleTickerstrikethrough,
  customizations
}) => {
  
  const tickerAr = tickerInfo.filter(item => item.sector_id === sector);
  if (tickerAr.length < 1) return null;
  const onClick = ({ event, ref, data, dataFromProvider }) => console.log('Hello');

  function onChangeInput(e, symbol) {
    updateStockInput({ 
      value: e.target.value, 
      name: e.target.name, 
      symbol: symbol,
      section: 'tickerInfo' 
    });

    updateDbStockInput({
      symbol: symbol,
      value: e.target.value,
      name: e.target.name,
      activePortfolioId: activePortfolioId
    });
  }

  return (
    tickerAr.map((item) => {

      const TickerContextMenu = () => (
        <ContextMenu theme={theme.dark} id={`context-menu-${item.symbol}`}>

          <Item onClick={() => toggleTickerstrikethrough({
            symbol: item.symbol, 
            flag: !item.strikethrough,
            portfolioId: activePortfolioId
          })}>Highlight</Item>

          <Item disabled onClick={onClick}>Remove</Item>
          <Item onClick={onClick}>Close</Item>
        </ContextMenu>
      );
      return (
        <tr key={item.symbol} className={currentTheme}>

          <td className={fillMLPrice(item.BofAML12, item.price)}>
            {format(item.BofAML12)}
          </td>

          <td className={fillUpside(item.upside)}>
            {formatPercent(item.upside)}
          </td>

          <td className={fillFiftyDayAvg(item.fiftyDayMovingAvg, item.price)}>
            {format(item.fiftyDayMovingAvg)}
          </td>

          <td className={inputFill(item.resistance, item.price)}> 
            <input 
              style={{ maxWidth: 40 }}
              className="cell-input"
              value={item.resistance} name="resistance"
              onChange={(e) => onChangeInput(e, item.symbol)} />
          </td>

          <td className={inputFill(item.price, item.support)}>
            <input 
              style={{ maxWidth: 40 }}  
              className="cell-input"
              value={item.support} name="support" 
              onChange={(e) => onChangeInput(e, item.symbol)} />
          </td>

          <td style={{ textAlign: 'center' }} className={fillStockWeight(item.stockWeight,customizations[0].tickerWeightGreen, customizations[0].tickerWeightRed)}>

            {formatPercent(item.stockWeight)}
          </td>

          <td className={earningDateColor(item.earningsDate)} 
              style={{ textAlign: 'left', cursor: 'pointer' }} 
              onClick={() => openModal(item)}>

            <ContextMenuProvider id={`context-menu-${item.symbol}`}>
              <span className={item.strikethrough ? 'strikethrough' : null}>
                {item.name} ({item.symbol})
              </span>
            </ContextMenuProvider>
            <TickerContextMenu />
          </td>

          <td>
            {format(item.price)}
          </td>

          <td className={priceColor(item.percentChange)}>
            {formatPercent(item.percentChange)}
          </td>

          <td className="circle-container">
            <a
              className={circleColor(item.MLRating)}
              // href={stockReportLink({ symbol: item.symbol, type: 'ML' })}
              target="_blank">
            </a>
          </td>

          {/*<td className="circle-container">*/}
          {/*  <a*/}
          {/*    className={circleColor(item.MSRating)}*/}
          {/*    href={stockReportLink({ symbol: item.symbol, type: 'MS' })}*/}
          {/*    target="_blank">*/}
          {/*  </a>*/}
          {/*</td>*/}

          {/*<td className="circle-container">*/}
          {/*  <a*/}
          {/*    className={circleColor(item.SNPRating)}*/}
          {/*    href={stockReportLink({ symbol: item.symbol, type: 'SnP' })}*/}
          {/*    target="_blank">*/}
          {/*  </a>*/}
          {/*</td>*/}
    
          <td></td>
          <td></td>
          <td></td> 
          <td></td>
          <td></td>
          <td></td> 
          <td></td>
          <td></td>

          <td className="no-padding" style={hide()}>
            <input 
              className="cell-input"
              value={item.quarterly} name="quarterly"
              onChange={(e) => onChangeInput(e, item.symbol)} />
          </td>

          <td></td>
    
          <td className={fillMaxMin(item.alphaPerf, 'alphaPerf', tickerInfo)}>
            {formatPercent(item.alphaPerf)}
          </td>

          <td style={hide()}>
            {format(item.quarterlyTotal)}
          </td>

          <td className="no-padding" style={hide()}>
            <input 
              className="cell-input" 
              value={item.adjCostbasis} name="adjCostbasis" 
              onChange={(e) => onChangeInput(e, item.symbol)} />
          </td>

          <td style={hide()}></td>
          <td style={hide()}></td>
          <td></td>
          <td></td>
          <td style={hide()}></td>
          <td style={hide()}></td>
          <td style={hide()}></td>
          <td></td>
          <td></td>
          <td></td>

          <td className="no-padding" style={hide()}>
            <input 
              className="cell-input"
              value={item.shares} name="shares"
              onChange={(e) => onChangeInput(e, item.symbol)} />
          </td>

          <td style={hide()}>
            {format(item.stockValue)}
          </td>

          <td className="no-padding">
            <input 
              className="cell-input"
              value={item.deck} name="deck"
              onChange={(e) => onChangeInput(e, item.symbol)} />
          </td>

          <td className="no-padding" style={hide()}>
            <input 
              style={{ width: 60 }}
              className="cell-input"
              value={item.notes} name="notes"
              onChange={(e) => onChangeInput(e, item.symbol)} />
          </td>

        </tr>
      )
    })   
  );
}

export default TableRow;